import { render, staticRenderFns } from "./AuthConfirmation.vue?vue&type=template&id=5b81aee8&"
import script from "./AuthConfirmation.vue?vue&type=script&lang=js&"
export * from "./AuthConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports